import React from "react";

import { FaLayerGroup } from "react-icons/fa";

import TutorialStepCard from "./TutorialStepCard";

const SECTION_COLORS = [
  {
    badge: "from-violet-600 to-indigo-600",
    eyebrow: "text-violet-600 dark:text-violet-300",
  },
  {
    badge: "from-sky-500 to-blue-600",
    eyebrow: "text-sky-600 dark:text-sky-300",
  },
  {
    badge: "from-emerald-500 to-teal-600",
    eyebrow: "text-emerald-600 dark:text-emerald-300",
  },
  {
    badge: "from-orange-500 to-rose-500",
    eyebrow: "text-orange-600 dark:text-orange-300",
  },
];

export default function TutorialSection({
  section,
  steps = [],
  index,
  elementId,
  searchActive = false,
  onOpenLightbox,
}) {
  const colors = SECTION_COLORS[index % SECTION_COLORS.length];

  return (
    <section
      id={elementId}
      data-tutorial-section={section.id}
      className="scroll-mt-36"
    >
      <header className="mb-5 flex items-start gap-4">
        <div
          className={`flex h-[52px] w-[52px] shrink-0 items-center justify-center rounded-[18px] bg-gradient-to-br ${colors.badge} text-lg font-bold text-white shadow-lg`}
          style={{
            width: "3.25rem",
            height: "3.25rem",
          }}
        >
          {index + 1}
        </div>

        <div className="min-w-0 flex-1">
          <div
            className={`flex items-center gap-2 text-xs font-bold uppercase tracking-[0.16em] ${colors.eyebrow}`}
          >
            <FaLayerGroup />
            Section {index + 1}
          </div>

          <h2 className="mt-1 text-2xl font-bold tracking-tight text-slate-900 dark:text-white">
            {section.label}
          </h2>

          <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
            {steps.length} étape
            {steps.length > 1 ? "s" : ""} dans cette section
          </p>
        </div>
      </header>

      {steps.length ? (
        <div className="space-y-4">
          {steps.map((step, stepIndex) => (
            <TutorialStepCard
              key={step.id || step.slug}
              step={step}
              index={stepIndex}
              forceOpen={searchActive}
              onOpenLightbox={onOpenLightbox}
            />
          ))}
        </div>
      ) : (
        <div className="rounded-[24px] border border-dashed border-slate-300 bg-white p-8 text-center dark:border-slate-700 dark:bg-slate-900">
          <p className="text-sm text-slate-500 dark:text-slate-400">
            Aucun contenu disponible dans cette section.
          </p>
        </div>
      )}
    </section>
  );
}
